const PALETTES = {
  lime: ["#E9FDC8", "#A3E635", "#5D8A0D"],
  gold: ["#FDF3C0", "#FACC15", "#A16207"],
};

export const TechIcon = ({ children, size = 22, id, color = "lime", led = [19, 5], className }) => {
  const [a, b, c] = PALETTES[color] || PALETTES.lime;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <defs>
        <linearGradient id={`tg-${id}`} x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor={a} />
          <stop offset="0.5" stopColor={b} />
          <stop offset="1" stopColor={c} />
        </linearGradient>
      </defs>
      <g stroke="#2A2E33" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" fill="none">{children}</g>
      <g stroke={`url(#tg-${id})`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" fill="none">{children}</g>
      {led && <circle cx={led[0]} cy={led[1]} r="1.25" fill="#EF4444" stroke="none" />}
    </svg>
  );
};

export const IconBack = (p) => (
  <TechIcon id="back" led={[19, 6]} {...p}>
    <path d="m12 19-7-7 7-7" />
    <path d="M19 12H5" />
  </TechIcon>
);

export const IconRefresh = (p) => (
  <TechIcon id="refresh" led={[12, 12]} {...p}>
    <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
    <path d="M21 3v5h-5" />
    <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
    <path d="M8 21H3v-5" />
  </TechIcon>
);

export const IconWallet = (p) => (
  <TechIcon id="wallet" led={[16, 13.5]} {...p}>
    <path d="M19 7V5a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v3h-4a2 2 0 0 0 0 4h4v3a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V6" />
  </TechIcon>
);

export const IconCart = (p) => (
  <TechIcon id="cart" led={[21, 4]} {...p}>
    <circle cx="8" cy="21" r="1" />
    <circle cx="19" cy="21" r="1" />
    <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
  </TechIcon>
);

export const IconMenu = (p) => (
  <TechIcon id="menu" led={[20.5, 6]} {...p}>
    <path d="M4 6h16" />
    <path d="M4 12h16" />
    <path d="M4 18h16" />
  </TechIcon>
);

export const IconBell = (p) => (
  <TechIcon id="bell" led={[18, 4.5]} {...p}>
    <path d="M10.3 21a2 2 0 0 0 3.4 0" />
    <path d="M3.26 15.33A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.67C19.41 13.96 18 12.5 18 8A6 6 0 0 0 6 8c0 4.5-1.41 5.96-2.74 7.33" />
  </TechIcon>
);

export const IconMessage = (p) => (
  <TechIcon id="msg" led={[16.5, 8.5]} {...p}>
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </TechIcon>
);

export const IconFaq = (p) => (
  <TechIcon id="faq" led={[19.5, 5]} {...p}>
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
    <path d="M12 17h.01" />
  </TechIcon>
);

export const IconMusic = (p) => (
  <TechIcon id="music" led={[21, 4]} {...p}>
    <path d="M9 18V5l12-2v13" />
    <circle cx="6" cy="18" r="3" />
    <circle cx="18" cy="16" r="3" />
  </TechIcon>
);

export const IconSwords = (p) => (
  <TechIcon id="swords" color="gold" led={null} {...p}>
    <path d="M14.5 17.5 3 6V3h3l11.5 11.5" />
    <path d="M13 19l6-6" />
    <path d="M16 16l4 4" />
    <path d="M19 21l2-2" />
    <path d="M14.5 6.5 18 3h3v3l-3.5 3.5" />
    <path d="M5 14l4 4" />
    <path d="M7 17l-3 3" />
    <path d="M3 19l2 2" />
  </TechIcon>
);
